"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 7.01v3.49l6 1.5-6 1.5v3.49l5.39-2.27c.6-1.74 1.86-3.16 3.48-3.97z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m11 12-6-1.5V7.01l8.87 3.73c.94-.47 2-.75 3.13-.75.1 0 .19.01.28.01L3 4v16l7-2.95V17c0-.8.14-1.56.39-2.28L5 16.99V13.5z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0 8-3-3h2.5v-3h1v3H20z"
}, "2")], 'SendAndArchiveTwoTone');